import { ChangeEvent } from 'react';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import * as Styles from './InputRating.styles';
import WarningMessage from '../WarningMessage';

export type CustomInputRatingProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  name: string;
  value: string;
  errorMessage?: string;
  hideInput?: boolean;
  ratingQuantity?: number;
  onChangeHandler?: (event: ChangeEvent<HTMLInputElement>) => void;
};

const InputRating = ({
  errorMessage,
  label,
  name,
  value,
  onChangeHandler,
  hideInput,
  disabled,
  ratingQuantity = 5,
  ...props
}: CustomInputRatingProps): JSX.Element => {
  const ratingQuantityArray = Array.from({ length: ratingQuantity }, (_, i) => `${i + 1}`);

  return (
    <Styles.InputBox data-testid="input-rating" {...props}>
      {label && <Styles.InputLabel htmlFor={name}>{label}</Styles.InputLabel>}
      {hideInput ? (
        <Styles.InputArea>—</Styles.InputArea>
      ) : (
        <Styles.InputArea>
          {ratingQuantityArray.map((ratingNumber) => (
            <Styles.StarLabel
              isFilled={ratingNumber <= value}
              key={ratingNumber}
              disabled={disabled}
              htmlFor={`${name}-${ratingNumber}`}
            >
              <input
                type="radio"
                disabled={disabled}
                onChange={onChangeHandler}
                id={`${name}-${ratingNumber}`}
                name={name}
                value={ratingNumber}
                checked={ratingNumber === value}
              />
              <StarOutlinedIcon sx={{ width: 13 }} />
            </Styles.StarLabel>
          ))}

          <WarningMessage errorMessage={errorMessage} data-testid="error-message" />
        </Styles.InputArea>
      )}
    </Styles.InputBox>
  );
};

export default InputRating;
